import { render, staticRenderFns } from "./surveys.vue?vue&type=template&id=d097a230&scoped=true&"
import script from "./surveys.vue?vue&type=script&lang=js&"
export * from "./surveys.vue?vue&type=script&lang=js&"
import style0 from "./surveys.vue?vue&type=style&index=0&id=d097a230&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d097a230",
  null
  
)

export default component.exports